<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes push-spider-1 {
    0%,
    12.5% {
      opacity: 1;
    }
    12.5%,
    25% {
      opacity: 0;
    }
    25%,
    37.5% {
      opacity: 1;
    }
    37.5%,
    50% {
      opacity: 0;
    }
    50%,
    62.5% {
      opacity: 1;
    }
    62.5%,
    75% {
      opacity: 0;
    }
    75%,
    87.5% {
      opacity: 1;
    }
    87.5%,
    100% {
      opacity: 0;
    }
  }
  #push-spider-1 {
    animation-name: push-spider-1;
  }
  @keyframes push-spider-2 {
    0%,
    12.5% {
      opacity: 0;
    }
    12.5%,
    25% {
      opacity: 1;
    }
    25%,
    62.5% {
      opacity: 0;
    }
    62.5%,
    75% {
      opacity: 1;
    }
    75%,
    100% {
      opacity: 0;
    }
  }
  #push-spider-2 {
    animation-name: push-spider-2;
  }
  @keyframes push-spider-3 {
    0%,
    37.5% {
      opacity: 0;
    }
    37.5%,
    50% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #push-spider-3 {
    animation-name: push-spider-3;
  }
  @keyframes push-spider-4 {
    0%,
    87.5% {
      opacity: 0;
    }
    87.5%,
    100% {
      opacity: 1;
    }
  }
  #push-spider-4 {
    animation-name: push-spider-4;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576.9 254" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="push-spider-1">
      <path
        fill="var(--flesh)"
        d="M466 254c-7-1-14-4-21-3a51 51 0 0 1-20-2c-7-2-10-7-9-14v-41c0-3-1-4-4-4l-9-2c-9-2-13-7-14-16l2-38 3-31a17 17 0 0 1 0-5c5-2 10-4 14-3l-2 18c1 5 0 5 5 5l-4 25-4 20c-1 7 2 9 8 10 3 1 3 0 3-3l1-19c0-11 2-22 1-33a72 72 0 0 1 9 1c3 0 8 3 11-2 1-1 4-1 4 1l3 1 6 1-2 3c-2 6-5 11-2 18 1 3 0 8-1 11l-6 36c-1 5-3 10-3 16l-3 23c0 2 1 2 3 2l7-2h3v3c-3 3 0 3 2 3a98 98 0 0 1 27 3c2 0 3 1 3 3-1 2 2 2 3 3 2 1 4 1 2 4l-1 2c1 2 0 2-2 2-4 1-6-1-10-1 2 2 2 3 0 5Z"
      />
      <path
        fill="var(--hair)"
        d="M54 192c1 0 3 0 1 2-4 6-3 14-1 21 0 1 0 2 2 2l18 6c4 1 5 8 1 10-12 7-25 11-39 6-8-2-13-7-16-15-2-8-7-16-11-24l-8-15v-4c6-6 12-11 21-10a15 15 0 0 0 8-1h1a11 11 0 0 1-3 8c-4 5-3 11 3 14a32 32 0 0 0 10 3c4 1 5 1 9-2a12 12 0 0 1 4-1Z"
      />
      <path
        fill="var(--shirt)"
        d="M411 118c-5 0-4 0-5-5l2-18c-4-1-9 1-14 3l-21 6c-10 4-21 7-31 12a8 8 0 0 1-6 0c-4-1-7 0-10 1a120 120 0 0 1-16 3c-2 0-3-1-4-3l-1-7-1-2a4 4 0 0 0 0-3 138 138 0 0 1-2-29 24 24 0 0 0-4-13c-4-8-5-17-4-25 4 0 8-1 11-3 2-1 3-2 4 0 1 1 2 0 3-1 5-2 9-4 14-2a4 4 0 0 0 2-1l39-13 15-4c18-2 35-2 52 3 6 2 13 4 18 8l6 3c3 0 3 1 4 3v2c1 6 0 12-2 17l-2 15c0 6 0 12-2 17-3 6-3 13-4 19l-3 19-6-1-3-1c-1-2-3-2-4-1-3 5-8 2-12 2a72 72 0 0 0-8-1Z"
      />
      <path
        fill="var(--pants)"
        d="M294 38c-1 8-1 17 4 25a24 24 0 0 1 4 13 138 138 0 0 0 2 29 4 4 0 0 1 0 3c-3 1-4 3-6 5a24 24 0 0 1-11 9c-14 6-28 12-43 15a186 186 0 0 0-43 17c-3 1-5-1-7-3l-7-10c0-2 2-2 3-3l1-2c-5-5-6-11-9-17l-9-18c0-1-1-3 1-3 14-7 26-18 40-26 12-7 24-13 34-22a60 60 0 0 1 16-10c9-4 18-6 28-3a13 13 0 0 1 2 1Z"
      />
      <path
        fill="var(--flesh)"
        d="m173 101 9 18c3 6 4 12 9 17l-1 2c-1 1-3 1-3 3l-8 2a95 95 0 0 1-14 5c-7 1-14 3-22 3-8 1-14 6-21 9a147 147 0 0 1-29 11l-15 4c-3 2-6 2-8 5-6 2-10 6-14 10l-2 2a12 12 0 0 0-4 1c-4 3-5 3-9 2a32 32 0 0 1-10-3c-6-3-7-9-3-14a11 11 0 0 0 3-8c8-1 15-5 21-9 3-2 7-3 9-6a6 6 0 0 0 1 0l14-8c4-2 8-7 10-12a20 20 0 0 0 12-5 41 41 0 0 1 15-7 25 25 0 0 0 8-4c8-6 16-12 27-15 8-2 16-2 25-3ZM456 82c2-5 2-11 2-17l2-15c2-5 3-11 2-17 3 2 6 5 9 3 4-2 10-2 14-5 2-2 6-1 8 2s1 6-1 8a15 15 0 0 1-5 3c-4 2-5 4-2 7a13 13 0 0 0 11 4c6-1 10 1 13 5 2 2 4 3 5 1s3-2 6-1 2 4 2 6a21 21 0 0 1-3 8l-10 5-6 2c-5-1-8 2-11 6-4 4-6 4-10 0h-3c-3 2-7 2-11 0a3 3 0 0 0-3-1c-5 2-6 1-9-4Z"
      />
      <path
        fill="var(--hair)"
        d="M519 74a21 21 0 0 0 3-8c0-2 0-5-2-6s-4 0-6 1-3 1-4-1c-4-5-8-6-14-5a13 13 0 0 1-11-4c-3-3-2-5 2-7a15 15 0 0 0 5-3c2-2 3-6 1-8s-5-4-8-2c-4 3-9 3-14 5-3 2-6-1-9-3v-2c-1-2-1-3 1-3a32 32 0 0 0 10-4c9-5 19-8 29-11 9-2 20 4 24 12l5 14a16 16 0 0 1 2 7 79 79 0 0 0 1 10l2 16c1 3-2 5-6 5s-7-2-11-3ZM86 135c-2 5-5 9-10 12l-14 8a6 6 0 0 1-1 0l-2-5c-2-8-1-8 6-11a30 30 0 0 1 11-3c3 0 5-1 7-3s4-1 3 2ZM70 180c2-3 5-3 8-5l15-4c-1 8-1 8 6 11 3 2 5 2 7 5 1 3 1 6-3 8-7 3-14 4-22 3a10 10 0 0 1-8-7l-3-11Z"
      />
    </g>
    <g id="push-spider-2">
      <path
        fill="var(--hair)"
        d="M577 192c-4 6-3 14-6 20-1 4 1 8-4 10s-7-2-10-5c1-3 3-5 3-8 1-4 2-9-4-7a3 3 0 0 1-4-1c-2-4-5-3-7-2a13 13 0 0 1-11-1 5 5 0 0 1-3-5c0-3 3-2 5-2h5c2 0 5-1 6-3 1-3-1-6-3-8-2-3-6-4-9-4-9 0-14-5-17-13 9-7 21-8 32-9 5-1 10-2 15 0a22 22 0 0 1 12 12ZM43 192c-4 6-6 12-8 18-1 3 0 5 3 6a31 31 0 0 1 7 4c5 3 5 8-1 11-8 5-27 3-33-4-4-5-5-12-5-18 0-11 1-22-4-33 0-1 0-3-2-4v-10c12-3 25-3 37-2a2 2 0 0 1 2 1c-7-1-11 3-14 10a19 19 0 0 1-2 3c-3 6-3 9 4 17 4 4 8 7 13 1h3Z"
      />
      <path
        d="M341 202c-7 3-12 9-20 10-18 1-35 3-53 2-12-1-24 1-35 3-9 1-11 0-13-8l-3-8c1-15 0-29-2-44 2-4 7-3 10-4s6-1 7-4 3-3 5-3l21-4a217 217 0 0 0 51-14 50 50 0 0 1 29-3c5 1 10 2 14 6-4 8-5 16-3 25a22 22 0 0 1 0 12 273 273 0 0 0-8 34Z"
        fill="var(--pants)"
      />
      <path
        fill="var(--flesh)"
        d="M215 157c2 15 3 29 2 44-16-4-33 0-49-3a40 40 0 0 1-7-2c-17-5-35-3-52-6-10-2-20-2-30-2-10-2-20 0-30 2-2 0-4 0-6 2h-3c-5 6-9 3-12-1-7-8-8-11-5-17a19 19 0 0 0 2-3c3-7 7-11 14-10h9a270 270 0 0 0 37-3c12 0 25-2 37-4 19-2 38-3 58 2 11 3 23 4 35 1Z"
      />
      <path
        fill="var(--shirt)"
        d="M341 202a273 273 0 0 1 8-34 22 22 0 0 0 0-12c-2-9-1-17 3-25 5 2 11 2 15 7a3 3 0 0 0 2 0c9-2 17 4 26 1 8 1 15-5 24-2-1 2-4 0-4 3l-5 15c-2 15 2 29 5 43 2 7 4 13 4 20a218 218 0 0 0-34 3c-12 2-23-4-35-5h-4c-5 0-5-3-5-6 1-3 2-5 0-8Z"
      />
      <path
        fill="var(--flesh)"
        d="M419 218c0-7-2-13-4-20-3-14-7-28-5-43l5-15c0-2 3-1 4-3-9-3-16 3-24 2l1-6c2-3 3-7 8-7 12 0 25 1 36 7-1 1-3 2 1 3 9 2 19 2 27 9 5 4 7 8 5 14l-4 10c-1 3-1 8-5 9-3 1-4 3-5 5-4 6-9 7-15 4-2-2-4-1-4 2l-2 11c-1 6-3 13 1 18-1 5 2 6 7 7a181 181 0 0 1 43 7c2 1 4 2 4 4l-4 4c-19 4-38 0-57 1-4 0-7-3-8-7a71 71 0 0 0-5-16Z"
      />
      <path
        fill="var(--shirt)"
        d="M439 218c-4-5-2-12-1-18l2-11c0-3 2-4 4-2 6 3 11 2 15-4l5-5c4-1 4-6 5-9l4-10c2-6 0-10-5-14-8-7-18-7-27-9-4-1-2-2-1-3 11 0 22 1 33 5a82 82 0 0 1 34 23 117 117 0 0 1-7 35 106 106 0 0 1-21 20c-7 5-16 5-24 4l-16-2Z"
      />
      <path
        fill="var(--flesh)"
        d="M500 196a117 117 0 0 0 7-35c3 3 7 2 11 2 3 8 8 13 17 13 3 0 7 1 9 4 2 2 4 5 3 8-1 2-4 3-7 3h-5c-2 0-4-1-4 2a5 5 0 0 0 3 6 13 13 0 0 0 11 0c2-1 5-2 7 2a3 3 0 0 0 4 1c6-2 5 3 4 7 0 3-2 5-3 8-10 2-21-1-30 6l-3 1c-4-4-11-2-15-6l-1-1c-10-1-7-8-6-14 0-2 1-6-2-7Z"
      />
      <path
        fill="var(--hair)"
        d="M85 158a270 270 0 0 1-37 3c-1-6 1-8 7-8 11 0 20 0 30 5ZM49 190c10-2 20-4 30-2l-4 6c-6 8-6 9 3 15 2 1 3 3 3 6 0 2-2 3-4 4-9 3-18 2-27-2-3-1-4-4-4-8l3-19Z"
      />
    </g>
    <g id="push-spider-3">
      <path
        fill="var(--hair)"
        d="M441 25c2-4 6-6 9-7 9-5 19-7 29-8 7-1 16 5 17 13l2 14 1 1v5c-2 3-2 6-2 9 1 6-1 12-1 18 0 4-3 5-7 4a20 20 0 0 1-7-4c2-3 4-6 4-9 0-4-2-6-5-4-2 1-3 1-4-1-2-3-4-3-7-1a13 13 0 0 1-9 1 5 5 0 0 1-5-4c0-2 0-3 3-3a27 27 0 0 0 8-1c3-1 4-4 3-7a8 8 0 0 0-6-6 46 46 0 0 0-11 0 8 8 0 0 1-6-2 29 29 0 0 1-6-8Z"
      />
      <path
        fill="var(--flesh)"
        d="M235 149s-2 1 0 1c3 0 4-2 5-4 3-6 7-13 13-16 7-4 11-9 15-14l4-4c8-9 16-18 26-26 2-2 5-3 6-6 4-1 8-4 11-7 5-2 8-6 11-9l14-13c3-4 7-6 9-10a5 5 0 0 0 3-1 5 5 0 0 1 6 0 17 17 0 0 1 9 11c0 3 1 7 4 9s1 4-1 7l-14 12c-1 1-2 3-4 3-6 2-11 7-18 8a4 4 0 0 0-2 2c-2 5-6 7-10 11-7 6-15 11-24 16h24a20 20 0 0 0 10-2l10 26c3 6 5 12 6 19a37 37 0 0 1-1 12c0 4-3 7-7 8-9 4-18 4-27 1-8-3-17-4-26-5l-28-5a30 30 0 0 1-4-1c-6-2-10 0-12 6 0 1-2 2-3 1-1-2-3-2-5 0-1 1-2 0-2-1-1-1 0-3-2-3-1-1-2-2-1-4 2-2 2-4 0-6-4-3-4-8-2-12 1-3 4-4 7-4Zm67 1a120 120 0 0 1-16-21l-4-1c-9 5-17 11-22 20-2 3-1 4 2 4h14c9-2 17-5 26-2Z"
      />
      <path
        fill="var(--pants)"
        d="M301 56a153 153 0 0 0 3 24c-1 3-4 4-6 6-10 8-18 17-26 26l-4 4c-5-6-5-6-11-2l-26 18c-2 1-4 1-5-1l-8-6a82 82 0 0 1-11-15 49 49 0 0 0-10-12c-2-2-4-4-7-4 2-5 6-8 10-11l19-16c6-6 12-12 16-19 4-8 11-15 18-20a33 33 0 0 1 22-6c8 0 12 5 15 10 5 8 8 16 11 24Z"
      />
      <path
        fill="var(--flesh)"
        d="M190 94c3 0 5 2 7 4a49 49 0 0 1 10 12 82 82 0 0 0 11 15l-16 6a12 12 0 0 0-4 2c-7 8-17 12-27 14-13 3-25 8-37 14l-40 15a77 77 0 0 0-21 13 26 26 0 0 0-5 5c0 1-1 2 1 3-8 1-13-3-17-9-3-5-2-12 1-14a21 21 0 0 0 6-6c2 1 3 0 4-1 13-7 25-16 38-25 8-6 16-13 26-16l16-4c15-3 28-9 39-21 2-2 4-5 8-7ZM418 91c1 7-1 13-2 20a22 22 0 0 0 1 11c2 6 1 12 0 19l-6 28c-1 9-1 17 1 26 0 2 2 4 4 3 6 0 12 2 18 0 1-1 2 0 3 1l12 5a2 2 0 0 1 2 2 2 2 0 0 1-2 3 7 7 0 0 1-6 0c-3-2-6-2-10-2 0 1 2 3 0 4a4 4 0 0 1-4 1c-5-2-11-2-16-2a40 40 0 0 1-6 0c-3-1-6-2-6-6l-8-42c-1-12-3-24-1-35 1-8-1-15-2-22l-1-9 5-1a5 5 0 0 1 5-1c4 2 9 2 13 1 2 0 5-1 6-4ZM422 55a18 18 0 0 0-6-1c-2 0-3-1-2-3a172 172 0 0 1 14-24 7 7 0 0 0 1-3l12 1a29 29 0 0 0 6 8 8 8 0 0 0 6 2 46 46 0 0 1 11 0 8 8 0 0 1 6 6c1 3 0 6-3 7a27 27 0 0 1-8 1c-3 0-3 1-3 3a5 5 0 0 0 5 4 13 13 0 0 0 9-1c3-2 5-2 7 1 1 2 2 2 4 1 3-2 5 0 5 4 0 3-2 6-4 9l-6 2c-3 2-7 3-11 3-2-1-4 1-6 2a19 19 0 0 1-5 4c-1 1-3 1-4-1s-2-2-4-1-5 1-7-2l-5-1c-2 0-4-1-4-4a19 19 0 0 1-1-6c2-8 1-8-7-11Z"
      />
      <path
        fill="var(--hair)"
        d="M59 168a21 21 0 0 1-6 6c-3 2-4 9-1 14 4 6 9 10 17 9v2c-3 6-3 13-4 20l2 2a49 49 0 0 1 11 3c4 1 5 4 3 7a13 13 0 0 1-6 5c-9 5-18 5-28 2a9 9 0 0 1-5-4c-4-6-6-13-7-21-2-6-4-13-8-19a40 40 0 0 1-6-12c0-2 0-4 2-5 12-4 23-7 35-9a7 7 0 0 1 1 0ZM235 149c-3 0-6 1-7 4-2 4-2 9 2 12 2 2 2 4 0 6-1 2 0 3 1 4-5 0-9 3-12 8-3 7-7 14-8 21a13 13 0 0 1-4 7c-3 4-6 4-9 0-5-12-8-24-3-36l9-28a27 27 0 0 1 2-4c2-4 3-4 7-4a71 71 0 0 1 20 7 9 9 0 0 1 3 2c1 1 0 1-1 1Z"
      />
      <path
        fill="var(--pants)"
        d="m322 103 6 2 4 12a20 20 0 0 1-10 2h-24c9-6 17-10 24-16Z"
      />
      <path
        fill="var(--shirt)"
        d="M428 27a7 7 0 0 0 1-3l-6-5c-5-4-9-9-15-12-8-4-16-4-25-6a30 30 0 0 0-15 0 69 69 0 0 1-25 3 11 11 0 0 0-4 0c-11 4-21 8-33 10a14 14 0 0 0-2 1l-22 4c-2 1-5 1-7 3 8 0 12 5 15 10 5 8 8 16 11 24a153 153 0 0 0 3 24c4-1 8-4 11-7 5-2 8-6 11-9l14-13c3-4 7-6 9-10a5 5 0 0 0 3-1 5 5 0 0 1 6 0 17 17 0 0 1 9 11c0 3 1 7 4 9s1 4-1 7l-14 12c-1 1-2 3-4 3-6 2-11 7-18 8a4 4 0 0 0-2 2c-2 5-6 7-10 11l6 2c5 2 10 2 14-1l20-10a10 10 0 0 1 4-1 62 62 0 0 0 22-6 36 36 0 0 0 0 4c0 2-1 4 1 5l5-1a5 5 0 0 1 5-1c4 2 9 2 13 1 2 0 5-1 6-4 2-1 3-3 3-5l1-31a18 18 0 0 0-6-1c-2 0-3-1-2-3a172 172 0 0 1 14-24Z"
      />
    </g>
    <g id="push-spider-4">
      <path
        fill="var(--flesh)"
        d="M379 81c-11 8-29 6-41 14-10 8-28 14-39 20s-11 27-23 33c-10 4-23 10-21 24a5 5 0 0 0 8 3l29-20a4 4 0 0 0 2-5l31-16a250 250 0 0 0 31-20l29-25c5-4-1-13-6-8Z"
      />
      <path
        fill="var(--hair)"
        d="M437 33c2-4 6-5 10-7 9-4 18-6 28-8 7-1 16 6 17 13 1 5 1 10 3 14v7c-2 2-1 6-1 8l-2 19c1 3-3 5-7 4a20 20 0 0 1-6-4c1-3 3-6 3-10 1-4-2-5-5-4h-4c-2-4-4-3-7-2a13 13 0 0 1-9 2 5 5 0 0 1-4-5c-1-2 0-2 2-3a27 27 0 0 0 8-1c3-1 4-3 4-6a8 8 0 0 0-7-6 46 46 0 0 0-11-1 8 8 0 0 1-5-2 28 28 0 0 1-7-8Z"
      />
      <path
        fill="var(--flesh)"
        d="m197 95 6 4a41 41 0 0 1 8 10 67 67 0 0 0 9 12l-13 5a10 10 0 0 0-3 2 44 44 0 0 1-23 11c-10 2-20 7-30 11l-33 13a63 63 0 0 0-17 11 21 21 0 0 0-4 4v2c-6 1-10-2-14-7-2-4-2-10 1-12a17 17 0 0 0 5-5h3l31-21c7-5 14-11 22-13l13-3c13-3 24-8 32-18l7-6ZM352 144c-3-7-8-12-12-18l-19-23a22 22 0 0 1-9 6l-24 7v-1c-5 4-11 8-14 13v1a4 4 0 0 1 1 0 2 2 0 0 1 3 1 128 128 0 0 0 23 16c-10 0-18 5-26 9-4 3-10 4-15 5h-3l-3 1a119 119 0 0 1-18 4 6 6 0 0 1-1 0 4 4 0 0 1-3 1v-1c-3 1-6 3-6 7s1 9 5 11c3 2 4 3 3 6-1 2 0 3 1 4 5-5 13-7 18-9a6 6 0 0 1 1 0 15 15 0 0 1 5-1 30 30 0 0 0 4-1c11-1 21-1 31-3 9-1 19-3 29-3 10 1 19-2 27-9 3-3 5-6 5-10a40 40 0 0 0-3-13Z"
      />
      <path
        fill="var(--hair)"
        d="M89 156a17 17 0 0 1-5 5c-3 2-3 8-1 12 4 5 8 8 14 7l1 2c-3 5-3 10-4 16l2 2a40 40 0 0 1 9 2c3 2 4 4 2 6a10 10 0 0 1-4 4c-8 4-16 4-24 2a8 8 0 0 1-4-3c-3-6-5-11-6-17s-3-11-6-16a34 34 0 0 1-5-10c0-2 0-3 2-4 9-4 19-6 28-8a5 5 0 0 1 1 0Z"
      />
      <path
        fill="var(--flesh)"
        d="M418 64a18 18 0 0 0-6-1c-2-1-3-1-2-3a173 173 0 0 1 15-25 6 6 0 0 0 1-2h11a28 28 0 0 0 7 8 8 8 0 0 0 5 2 46 46 0 0 1 11 1 8 8 0 0 1 7 6c0 3-1 5-4 6a27 27 0 0 1-8 1c-2 1-3 1-2 3a5 5 0 0 0 4 5 13 13 0 0 0 9-2c3-1 5-2 7 1 1 2 2 2 4 1 3-1 6 0 5 4 0 4-2 7-3 10l-7 2-11 2c-2 0-4 1-5 3a19 19 0 0 1-5 4c-2 1-4 1-5-2-1-2-2-2-3-1-3 1-6 1-8-2l-4-1c-3 1-5-1-5-3a19 19 0 0 1 0-7c1-7 0-8-8-10Z"
      />
      <path
        fill="var(--hair)"
        d="M232 165c-3 1-6 3-6 7s1 9 5 11c3 2 4 3 3 6-1 2 0 3 2 4-5 2-8 6-10 12-1 8-3 16-2 25a14 14 0 0 1-1 8c-2 4-6 5-9 2-10-10-16-22-15-36l1-31a28 28 0 0 1 0-5c1-5 2-5 7-6a75 75 0 0 1 22 1 10 10 0 0 1 4 1l-1 1Z"
      />
      <path
        fill="var(--pants)"
        d="M342 113c0-3-1-6-5-5h-1a17 17 0 0 0-8-7c-6-3-11-4-14-10l-9-16a110 110 0 0 0-8-11c-3-8-5-16-10-23-4-6-8-11-15-11a33 33 0 0 0-23 7c-7 5-13 11-18 19-4 7-10 14-16 20l-18 16-11 10 7 5a49 49 0 0 1 10 11 82 82 0 0 0 11 15l8 7h5l27-17c6-4 6-4 10 1a5 5 0 0 0 1 0 37 37 0 0 0 4 6c3 4 7 5 12 5 11 1 23 0 33-4h1a40 40 0 0 0 27-11c3-2 2-5 0-7Z"
      />
      <path
        fill="var(--pants)"
        d="m319 112 6 2 3 11a20 20 0 0 1-10 3h-23l24-16Z"
      />
      <path
        fill="var(--flesh)"
        d="M418 87a3 3 0 0 1 1 0l-3 25a28 28 0 0 0 1 14c3 8 2 16 0 24-2 13-6 25-7 37-2 11-2 22 0 33 1 3 3 5 6 4 7 0 15 3 22 0 2-1 3 0 5 1 5 2 10 6 15 7a2 2 0 0 1 2 3 3 3 0 0 1-2 3c-3 0-5 1-7-1-4-2-8-2-13-1 0 1 2 3 0 5a5 5 0 0 1-5 0c-7-2-14-2-22-2a51 51 0 0 1-7 0c-4-1-7-3-8-7-2-18-8-36-10-54-1-15-3-30-1-46 1-9-1-18-2-28l-2-12h7a7 7 0 0 1 6-1c5 2 11 1 17 1 2-1 6-2 7-5Z"
      />
      <path
        fill="var(--shirt)"
        d="m431 46 2-17-1-3c0-2-1-3-4-3l-5-2c-6-5-12-7-18-9a133 133 0 0 0-67 1l-39 14a4 4 0 0 1-3 0c-5-1-9 0-13 3h-7l-9 3a5 5 0 0 1 0 3 108 108 0 0 0 2 20 4 4 0 0 1 4 2c8 18 21 32 34 45a87 87 0 0 0 17 3l20-7 21-6c5-2 9-3 14-2l-2 17c0 5 0 5 5 5h4a72 72 0 0 1 9 1c4 1 8 3 12-2 0 0 3-1 4 1s2 2 3 2h6l3-19c1-6 0-13 4-19 2-5 1-11 1-17 0-5 2-10 3-14Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>